import axiosInstance from "../server/axios";

export const getRefundRequests = async (params = {}) => {
  try {
    const response = await axiosInstance.get('/admin/remboursements/demandes', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const approveRefund = async (demandeId) => {
  try {
    const response = await axiosInstance.post(`/admin/remboursements/approuver/${demandeId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const rejectRefund = async (demandeId, reponseAdmin) => {
  try {
    const response = await axiosInstance.post(`/admin/remboursements/refuser/${demandeId}`, {
      reponse_admin: reponseAdmin
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};